/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $BadgePatch = {
    properties: {
        name: {
            type: 'any-of',
            contains: [{
                type: 'TranslationCreate',
            }, {
                type: 'null',
            }],
        },
        description: {
            type: 'any-of',
            contains: [{
                type: 'TranslationCreate',
            }, {
                type: 'null',
            }],
        },
        teamId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
